module.exports = __WEBPACK_EXTERNAL_MODULE_162__;


//////////////////
// WEBPACK FOOTER
// external "react-portal"
// module id = 162
// module chunks = 0